export class EvidencesForLabeling {
  constructor(public Categories: string[], public EvidenceUids: string[], public OrganisationalId: string, public Description?: string | null, public Title?: string | null) {}
}

export class SearchUnlabeledEvidencesDate {
  constructor(public Date: string) {}
}
